<!-- 补贴发放订单详情 -->
<template>
  <div class="app-container order-detail-wrap">
    <!-- 基础信息 -->
    <div class="module-wrap">
      <el-descriptions title="基础信息" :column="4" class="common-description-border">
        <el-descriptions-item label="补贴单号">{{
          formData.subsidyNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="发放状态">{{
          formData.statusName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="补贴类型">{{
          formData.subsidyTypeName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="销售单行号">{{
          formData.salesNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="售后工单号">{{
          formData.infoNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="渠道">
          {{ formData.channel || "--" }}
        </el-descriptions-item>
        <el-descriptions-item label="网点编号">{{
          formData.outletsNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="网点名称">{{
          formData.outletsName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="来源系统">{{
          formData.sourceSystem || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="鉴定时间">
          {{ formData.appraisalDate || "--" }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 新机信息 -->
      <el-descriptions title="新机信息" :column="4" class="common-description-border">
        <el-descriptions-item label="新机型号">{{
          formData.newMachineModel || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="购买时间">{{
          formData.buyDate || "--"
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 旧机信息 -->
    <div class="module-wrap">
      <el-descriptions title="旧机信息" :column="4" class="common-description-border">
        <el-descriptions-item label="旧机品牌">{{
          formData.oldMachineBrand || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机类型">{{
          formData.oldMachineTypeName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机规格">{{
          formData.oldMachineSpecification || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="回收地址">{{
          formData.recoveryAddress || "--"
        }}
          <span v-if="formData.recoveryAddress">
            <img v-if="!dataVisible.recoveryAddress" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="回收联系人">{{
          formData.recoveryContact || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="回收联系人电话">{{
          formData.recoveryTel || "--"
        }}
          <span v-if="formData.recoveryTel">
            <img v-if="!dataVisible.recoveryTel" src="@/assets/eye-close.png" @click="toggleVisibility('recoveryTel')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('recoveryTel')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="旧机完整情况">{{
          formData.oldMachineSituation || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="旧机图片">
          <template v-if="oldMachinePhotoList.length === 0">--</template>
          <template v-else>
            <el-image
              v-for="(item, index) in oldMachinePhotoList"
              :key="index"
              :src="item"
              class="image-style"
              fit="cover"
              :preview-src-list="oldMachinePhotoList"
            ></el-image>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="鉴定补贴金额">{{
          formData.subsidyAmount || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="是否有铜管">{{
          (formData.copperPipeFlag == 1 ? '有' : '无') || "--"
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 收款信息 -->
      <el-descriptions title="收款信息" :column="4" class="common-description-border">
        <el-descriptions-item label="收款人姓名">{{
          formData.payeeName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="收款人手机号">{{
          formData.payeeTel || "--"
        }}
          <span v-if="formData.payeeTel">
            <img v-if="!dataVisible.payeeTel" src="@/assets/eye-close.png" @click="toggleVisibility('payeeTel')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('payeeTel')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="收款人身份证">{{
          formData.payeeCard || "--"
        }}
          <span v-if="formData.payeeCard">
            <img v-if="!dataVisible.payeeCard" src="@/assets/eye-close.png" @click="toggleVisibility('payeeCard')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('payeeCard')" />
          </span></el-descriptions-item>
        <el-descriptions-item label="银行卡号">{{
          formData.payeeBankAccount || "--"
        }}
          <span v-if="formData.payeeBankAccount">
            <img v-if="!dataVisible.payeeBankAccount" src="@/assets/eye-close.png" @click="toggleVisibility('payeeBankAccount')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('payeeBankAccount')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="开户支行名称">{{
          formData.openBank || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="支行号">{{
          formData.openBankNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="支行所在地">{{
          formData.openBankAddress != 'nullnull' ? formData.openBankAddress : "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="收款信息提交时间">{{
          formData.collectionSubmitDate || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="反向开票协议签名">
          <template v-if="formData.reverseInvoicingAgreementSignature">
            <el-image
              :src="formData.reverseInvoicingAgreementSignature"
              class="image-style"
              fit="cover"
              :preview-src-list="[formData.reverseInvoicingAgreementSignature]"
            ></el-image>
          </template>
          <template v-else> -- </template>
        </el-descriptions-item>
        <el-descriptions-item label="反向开票协议" >
          <template v-if="formData.reverseInvoicingAgreement">
            <el-image
              :src="formData.reverseInvoicingAgreement"
              class="image-style"
              fit="cover"
              :preview-src-list="[formData.reverseInvoicingAgreement]"
            ></el-image>
          </template>
          <template v-else> -- </template>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 付款信息 -->
      <el-descriptions title="付款信息" :column="4" class="common-description-border">
        <el-descriptions-item label="付款账户">{{
          formData.paymentAccount || "--"
        }}
         <span v-if="formData.paymentAccount">
            <img v-if="!dataVisible.paymentAccount" src="@/assets/eye-close.png" @click="toggleVisibility('paymentAccount')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('paymentAccount')" />
          </span>
      </el-descriptions-item>
        <el-descriptions-item label="付款流水号">{{
          formData.paymentSerialNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="付款银行">{{
          formData.paymentBank || "--"
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 补贴发放进度记录 -->
      <div class="table">
        <div class="table-head">补贴发放进度记录</div>
        <el-table :data="subsidyDistributionProgressRecord">
          <el-table-column prop="subsidyNodeName" label="节点" width="180">
          </el-table-column>
          <el-table-column
            prop="createdName"
            label="操作人"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="createdDate"
            label="时间"
            width="320"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 导出记录 -->
      <div class="table">
        <div class="table-head">导出记录</div>
        <el-table :data="exportRecord">
          <el-table-column type="index" label="序号" width="180">
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="类型"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="createdName"
            label="操作人"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="createdDate"
            label="时间"
            width="150"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
// import { getRecoveryOrderByOrderNo } from "@/api/oldForNew";
import enumMixin from '../COldForNewService/enumMixin';
export default {
  name: "orderDetail",
  components: {},
  mixins: [enumMixin],
  data() {
    return {
      orderNo: this.$route.query.orderNo,
      //回收详情对象
      formData: {},
      // 补贴发放进度记录
      subsidyDistributionProgressRecord: [],
      // 导出记录
      exportRecord: [],
      productImageBase64: "",
      // 旧机图片
      oldMachinePhotoList: [],
      originData: {},
      dataVisible: {
        payeeBankAccount: false,
        payeeCard: false,
        payeeTel: false,
        recoveryTel: false,
        recoveryAddress:false,
        paymentAccount:false
      }
    };
  },
  async created() {
    // this.getDetail();
    if (this.orderNo) {
      this.getDetail();
    }
  },
  methods: {
    //获取回收详情
    async getDetail() {
      // let params = this.orderNo;
      // this.list = [];
      // this.listLoading = true;

      // /api/oldMachineSubsidy/getSubsidyDetailsBysubsidyNo/{subsidyNo}
      this.HttpService.post(
        // JJBT2024051701000009
        `/autoapp-default-server-recovery/api/oldMachineSubsidy/getSubsidyDetailsBysubsidyNo/${this.orderNo}`,
        // `/autoapp-default-server-recovery/api/oldMachineSubsidy/getSubsidyDetailsBysubsidyNo/JJBT2024051701000009`,
        {}
      ).then(async (res) => {
        if (res.statusCode === 200) {
          console.log("工单详情数据", res.data);
          // 处理发放状态
          if(res.data.onlineStatus){
            switch(res.data.onlineStatus){
              case 1:
                res.data.statusName = "待补充收款信息";
                break;
              case 2:
                res.data.statusName = "支付中";
                break;
              case 3:
                res.data.statusName = "支付成功";
                break;
              case 4:
                res.data.statusName = "支付失败";
                break;
              case 5:
                res.data.statusName = "支付异常";
                break;
              case 6:
                res.data.statusName = "对账异常";
                break;
            }
          }else{
            switch (res.data.status) {
              case 1:
                res.data.statusName = "待填写收款信息";
                break;
              case 2:
                res.data.statusName = "待业务审核";
                break;
              case 3:
                res.data.statusName = "待补贴发放";
                break;
              case 4:
                res.data.statusName = "补贴发放中";
                break;
              case 5:
                res.data.statusName = "待开票";
                break;
              case 6:
                res.data.statusName = "补贴发放失败";
                break;
              case 7:
                res.data.statusName = "开票完成";
                break;
              case 8:
                res.data.statusName = "已关闭";
                break;
              case 21:
                res.data.statusName = " 审核驳回";
                break;
            }
          }
          // 处理补贴类型
          switch (res.data.subsidyType) {
            case "1":
              res.data.subsidyTypeName = "以旧换新";
              break;
            case "2":
              res.data.subsidyTypeName = "回收";
              break;
          }
          // 处理旧机类型
          switch (res.data.oldMachineType) {
            case 101:
              res.data.oldMachineTypeName = "家用空调";
              break;
            case 102:
              res.data.oldMachineTypeName = "电视机";
              break;
            case 103:
              res.data.oldMachineTypeName = "热水器";
              break;
            case 104:
              res.data.oldMachineTypeName = "电脑";
              break;
            case 106:
              res.data.oldMachineTypeName = "冰箱";
              break;
            case 109:
              res.data.oldMachineTypeName = "壁挂炉";
              break;
            case 115:
              res.data.oldMachineTypeName = "厨大电";
              break;
            case 117:
              res.data.oldMachineTypeName = "洗衣机";
              break;
          }
          // 处理补贴发放进度记录节点
          if (
            res.data.issuedRecordEntityList &&
            res.data.issuedRecordEntityList.length !== 0
          ) {
            res.data.issuedRecordEntityList.forEach((item) => {
              if (item.subsidyNode === 1) {
                item.subsidyNodeName = "旧机鉴定完成";
              } else if (item.subsidyNode === 2) {
                item.subsidyNodeName = "提交收款信息";
              } else if (item.subsidyNode === 3) {
                item.subsidyNodeName = "业务审核完成";
              } else if (item.subsidyNode === 4) {
                item.subsidyNodeName = "操作发放";
              } else if (item.subsidyNode === 5) {
                item.subsidyNodeName = "发放完成";
              } else if (item.subsidyNode === 6) {
                item.subsidyNodeName = "发放失败";
              } else if (item.subsidyNode === 7) {
                item.subsidyNodeName = "重新提交收款信息";
              } else if (item.subsidyNode === 8) {
                item.subsidyNodeName = "开票完成";
              } else if (item.subsidyNode === 9) {
                item.subsidyNodeName = "已关闭";
              } else if (item.subsidyNode === 21) {
                item.subsidyNodeName = "审核驳回";
              } else if (item.subsidyNode === 31) {
                item.subsidyNodeName = "业务审核驳回";
              }else if (item.subsidyNode === 10) {
                item.subsidyNodeName = '通知易宝付款'
              }else if (item.subsidyNode === 11) {
                item.subsidyNodeName = '易宝回传付款成功'
              }else if (item.subsidyNode === 12) {
                item.subsidyNodeName = '易宝回传付款失败'
              }else if (item.subsidyNode === 13) {
                item.subsidyNodeName = '定时任务重新请求付款'
              }
            });
          }
          // 处理导出记录类型
          if (
            res.data.exportRecordEntityList &&
            res.data.exportRecordEntityList.length !== 0
          ) {
            res.data.exportRecordEntityList.forEach((item) => {
              if (item.type === 1) {
                item.typeName = "发放";
              } else if (item.type === 2) {
                item.typeName = "导出";
              }
            });
          }
          // 处理旧机图片
          if (
            res.data.oldMachinePhoto &&
            res.data.oldMachinePhoto.indexOf("http") < 0
          ) {
            // let imgArr = [
            //   "1663058853901377537/mOjGB5dC8Lpn8e216e9415e191f27fefeeba4e74a5cb.jpeg",
            //   "1701517685535969282/9dHTdKyxfZDya56c56771d112eef21bfb1757e0705c2.png",
            //   "1663058853901377537/mOjGB5dC8Lpn8e216e9415e191f27fefeeba4e74a5cb.jpeg",
            //   "1701517685535969282/9dHTdKyxfZDya56c56771d112eef21bfb1757e0705c2.png"
            // ];
            let imgArr = [];
            imgArr = res.data.oldMachinePhoto.split(",");
            if (imgArr && imgArr.length !== 0) {
              for (let index = 0; index < imgArr.length; index++) {
                this.changeImg(imgArr[index]);
              }
            }
          }

          this.formData = res.data;
          //处理反向协议图片
          if (res.data.reverseInvoicingAgreement) {
            if (res.data.reverseInvoicingAgreement.startsWith("http")) {
              this.formData.reverseInvoicingAgreement =
                res.data.reverseInvoicingAgreement;
            } else {
              this.formData.reverseInvoicingAgreement =
                await this.changeSignImg(res.data.reverseInvoicingAgreement);
            }
          }

          if (res.data.reverseInvoicingAgreementSignature) {
            if (
              res.data.reverseInvoicingAgreementSignature.startsWith("http")
            ) {
              this.formData.reverseInvoicingAgreementSignature =
                res.data.reverseInvoicingAgreementSignature;
            } else {
              this.formData.reverseInvoicingAgreementSignature =
                await this.changeSignImg(
                  res.data.reverseInvoicingAgreementSignature
                );
            }
          }
          console.log("看看详情数据", res.data);
          this.subsidyDistributionProgressRecord =
            res.data.issuedRecordEntityList;
          this.exportRecord = res.data.exportRecordEntityList;
          // this.list = res.data;

          this.originData = res.data ? {...res.data} : {};

          // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            payeeBankAccount_bankCard: 'payeeBankAccount',
            payeeCard_idCard: 'payeeCard',
            payeeTel_phone: 'payeeTel',
            recoveryTel_phone: 'recoveryTel',
            recoveryAddress_address: 'recoveryAddress',
            paymentAccount_bankCard:'paymentAccount'
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
        }
      });
    },
    async changeSignImg(imgUrl) {
      if (imgUrl) {
        const response = await this.axios({
          url:
            process.env.BASE_API +
            `/autoapp-default-server-recovery/api/sms-annex/download-file?fileId=${imgUrl}`,
          method: "GET",
          headers: { Authorization: this.$store.getters.token },
        });
        return response.request.responseURL;
      }
    },
    //获取图片地址
    async changeImg(imgUrl) {
      if (imgUrl) {
        await this.axios({
          url:
            process.env.BASE_API +
            `/autoapp-default-server-recovery/api/sms-annex/download-file?fileId=${imgUrl}`,
          method: "GET",
          headers: {
            // 设置请求头
            Authorization: this.$store.getters.token,
          },
        }).then((res) => {
          // return res.request.responseURL;
          this.oldMachinePhotoList.push(res.request.responseURL);
          console.log(
            "响应了什么值",
            res.request.responseURL,
            this.oldMachinePhotoList
          );
        });

        return;
      }
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'payeeBankAccount':
          if (this.dataVisible.payeeBankAccount && this.payeeBankAccount.message) {
            this.getSourceOrigin(this.payeeBankAccount).then(res => {
              this.$set(this.formData, 'payeeBankAccount', res)
            })
          } else if (!this.dataVisible.payeeBankAccount) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'payeeBankAccount', this.originData.payeeBankAccount)
          }
          break
          case 'payeeCard':
            if (this.dataVisible.payeeCard && this.payeeCard.message) {
              this.getSourceOrigin(this.payeeCard).then(res => {
                this.$set(this.formData, 'payeeCard', res)
              })
            } else if (!this.dataVisible.payeeCard) {
              // 还原为原始脱敏数据
              this.$set(this.formData, 'payeeCard', this.originData.payeeCard)
            }
            break
            case 'payeeTel':
              if (this.dataVisible.payeeTel && this.payeeTel.message) {
                this.getSourceOrigin(this.payeeTel).then(res => {
                  this.$set(this.formData, 'payeeTel', res)
                })
              } else if (!this.dataVisible.payeeTel) {
                // 还原为原始脱敏数据
                this.$set(this.formData, 'payeeTel', this.originData.payeeTel)
              }
              break
              case 'recoveryTel':
                if (this.dataVisible.recoveryTel && this.recoveryTel.message) {
                  this.getSourceOrigin(this.recoveryTel).then(res => {
                    this.$set(this.formData, 'recoveryTel', res)
                  })
                } else if (!this.dataVisible.recoveryTel) {
                  // 还原为原始脱敏数据
                  this.$set(this.formData, 'recoveryTel', this.originData.recoveryTel)
                }
        case 'recoveryAddress':
          if (this.dataVisible.recoveryAddress && this.recoveryAddress.message) {
            this.getSourceOrigin(this.recoveryAddress).then(res => {
              this.$set(this.formData, 'recoveryAddress', res)
            })
          } else if (!this.dataVisible.recoveryAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'recoveryAddress', this.originData.recoveryAddress)
          }
          break
          case 'paymentAccount':
            if (this.dataVisible.paymentAccount && this.paymentAccount.message) {
              this.getSourceOrigin(this.paymentAccount).then(res => {
                this.$set(this.formData, 'paymentAccount', res)
              })
            } else if (!this.dataVisible.paymentAccount) {
              // 还原为原始脱敏数据
              this.$set(this.formData, 'paymentAccount', this.originData.paymentAccount)
            }
      }
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
    .table-head {
      margin-bottom: 20px;
      margin-top: 20px;
      color: #303133;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/orderDetail.vue